import { useState } from 'react'
import { Field, inputClass } from './modal-form'
import { STATION_LOCATIONS } from '../types'

// Event Location as a dropdown of NYMR station locations (item 6), replacing
// the old free-text input on the New/Edit event modals.
//
// The value is still a plain string stored in Events.location, so this is a
// pure UI change — no migration. Any pre-existing free-text location that
// isn't one of the known stations is preserved: the picker opens on "Other…"
// with the original text kept in an adjacent input the user can edit.

const OTHER = '__other__'

interface Props {
  value: string
  onChange: (value: string) => void
  disabled?: boolean
}

export function StationLocationField({ value, onChange, disabled }: Props) {
  const isKnownStation =
    value !== '' && (STATION_LOCATIONS as readonly string[]).includes(value)

  // The select's own value: '' (no location), a station name, or the OTHER
  // sentinel. We keep it in local state so that choosing "Other…" and then
  // clearing the text input doesn't snap the select back to "No location".
  const [mode, setMode] = useState<string>(
    value === '' ? '' : isKnownStation ? value : OTHER
  )

  return (
    <Field label="Location">
      <select
        value={mode}
        disabled={disabled}
        onChange={(e) => {
          const next = e.target.value
          setMode(next)
          // OTHER → clear until they type (submit trims); otherwise the value
          // is the chosen station name, or '' for "No location".
          onChange(next === OTHER ? '' : next)
        }}
        className={inputClass(false)}
      >
        <option value="">— No location —</option>
        {STATION_LOCATIONS.map((s) => (
          <option key={s} value={s}>{s}</option>
        ))}
        <option value={OTHER}>Other (type a location)…</option>
      </select>
      {mode === OTHER && (
        <input
          type="text"
          value={value}
          disabled={disabled}
          maxLength={255}
          autoFocus
          placeholder="e.g. Eskdale, or a specific venue"
          onChange={(e) => onChange(e.target.value)}
          className={`${inputClass(false)} mt-2`}
        />
      )}
    </Field>
  )
}
